export default __webpack_public_path__ + "static/B0294-52bfb2ed1adf6ecf6e9e5be8b3040fcf.png";